import fetch from 'isomorphic-fetch'
import { getAPIendpointPrefix } from './apiHelper.js'

import {
  LOAD_ACTIVITY_COMPLETION_TIME_REQUEST,
  LOAD_ACTIVITY_COMPLETION_TIME_SUCCESS,
  LOAD_ACTIVITY_COMPLETION_TIME_FAILURE
} from '../actions'

export default ({ assignmentId }) => {
  return (dispatch) => {
    dispatch({ type: LOAD_ACTIVITY_COMPLETION_TIME_REQUEST })

    const endpoint = getAPIendpointPrefix() + 'api/v1/activity_completion_time.php?' +
      `&assignment_id=${assignmentId}`

    return fetch(endpoint)
      .then(response => {
        const contentType = response.headers.get('content-type')
        if (contentType && contentType.includes('application/json')) {
          return response.json()
        } else {
          return Promise.resolve({ error: response.statusText })
        }
      })
      .then(json => {
        if (json.error) {
          return dispatch({ type: LOAD_ACTIVITY_COMPLETION_TIME_FAILURE, payload: json })
        }
        return dispatch({ type: LOAD_ACTIVITY_COMPLETION_TIME_SUCCESS, payload: json })
      })
      .catch(error => {
        return dispatch({ type: LOAD_ACTIVITY_COMPLETION_TIME_FAILURE, payload: { error: error.message } })
      })
  }
}
